import {
    getCachedTableDataSlice,
    getCachedTableResultSelector,
} from 'src/hooks/common-data-service/cached-table';

import {userRoleAuditLogStateSelector} from './user-role-audit-log-state.slice';

import type {CachedTableCacheSelector, CachedTableDataSelector} from 'src/hooks/common-data-service/cached-table/typedef';
import type {AdminChangeLog} from 'src/openapi/admin/models/AdminChangeLog';

export const userRoleAuditLogSlice = getCachedTableDataSlice<
    AdminChangeLog[],
    undefined,
    undefined,
    undefined
>('userRoleAuditLog');

export const userRoleAuditLogActions = userRoleAuditLogSlice.actions;
export const userRoleAuditLogCacheSelector: CachedTableCacheSelector<AdminChangeLog[]>
    = state => state.userPage.tabs.userRoleAuditLog.result.cache;
export const userRoleAuditLogDataSelector: CachedTableDataSelector<AdminChangeLog[]>
    = state => state.userPage.tabs.userRoleAuditLog.result;

export const userRoleAuditLogResultSelector = getCachedTableResultSelector(
    userRoleAuditLogCacheSelector,
    userRoleAuditLogStateSelector,
);
